import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { imgSrc } from "@/lib/api";

export default function Footer() {
  const { content } = useContent();
  const s = content.site;
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F10] text-[#E5E7EB] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            {s.logo_image_dark || s.logo_image ? (
              <img src={imgSrc(s.logo_image_dark || s.logo_image)} alt={s.name} className="h-12 w-auto max-w-[180px] object-contain" />
            ) : (
              <div className="w-10 h-10 bg-[#D4AF37] flex items-center justify-center">
                <span className="font-display text-[#1A1A1A] text-xl">V</span>
              </div>
            )}
            <div>
              <div className="font-display text-xl text-white">{s.name.split("&")[0]?.trim() || "Victory Aluminium"}</div>
              <div className="tracking-eyebrow text-[#9CA3AF] text-[10px]">{s.tagline}</div>
            </div>
          </div>
          <p className="text-[#9CA3AF] text-sm leading-relaxed max-w-sm">{content.footer.note}</p>
          <div className="mt-8 flex items-center gap-3">
            <span className="tracking-eyebrow text-[#D4AF37]">Est.</span>
            <span className="font-display text-3xl text-white">1998</span>
            <span className="text-[#6B7280] text-xs ml-2">Experience since 1986</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="tracking-eyebrow text-[#D4AF37] mb-5">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {[["/about", "About Us"], ["/products", "Products"], ["/partnership", "City BOND Partnership"], ["/manufacturing", "Manufacturing"], ["/projects", "Projects"], ["/reviews", "Reviews"]].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="hover:text-[#D4AF37] transition-colors inline-flex items-center gap-1.5">{label} <ArrowUpRight className="w-3 h-3" /></Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="tracking-eyebrow text-[#D4AF37] mb-5">Get In Touch</h4>
          <ul className="space-y-4 text-sm text-[#D1D5DB]">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37] shrink-0" />
              <span>{s.primary_address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#D4AF37]" />
              <a href={`tel:${s.phone}`} className="hover:text-white">{s.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#D4AF37]" />
              <a href={`mailto:${s.email}`} className="hover:text-white">{s.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1F2024]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6B7280]">© {new Date().getFullYear()} {s.name}. All rights reserved.</p>
          <p className="text-xs text-[#6B7280]">{content.footer.motto}</p>
        </div>
      </div>
    </footer>
  );
}
